import { SlicePipe } from '@angular/common';
import { Component, Input, signal, WritableSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';
import {
    ClaimStatus,
    ReviewMessageResponse,
    ReviewMessageType,
} from 'lemunzo-api';
import { Observable } from 'rxjs';
import { MatDialogWidth } from '../../enums/mat-dialog-width';
import { DialogData } from '../../models/notification-dialog-model';
import { TranslateDatePipe } from '../../pipes/translate-date.pipe';
import { SharedDialogService } from '../../services/shared-dialog.service';
import { NotificationDialogComponent } from '../notification-dialog/notification-dialog.component';

// TODO #CSD-1625: wire NotificationReaderComponent to a real ReviewMessage data source
@Component({
    selector: 'apcam-notification-reader',
    styleUrls: ['./notification-reader.component.scss'],
    templateUrl: './notification-reader.component.html',
    imports: [
        MatButtonModule,
        MatCardModule,
        MatDividerModule,
        SlicePipe,
        TranslateDatePipe,
        TranslatePipe,
    ],
})
export class NotificationReaderComponent {
    @Input()
    cardTitle: string = 'Title';

    @Input()
    notificationType: ReviewMessageType = ReviewMessageType.Claim;

    @Input()
    entityId: number = 0;

    @Input({ required: true })
    numOfNotificationsToDisplay: number = 0;

    @Input()
    statusChanges: Observable<ClaimStatus> | null = null;

    @Input()
    notifications: WritableSignal<ReviewMessageResponse[]> = signal([]);
    loading: boolean = true;

    constructor(private readonly dialogService: SharedDialogService) {}

    protected openNotificationsDialog(): void {
        this.dialogService.open<NotificationDialogComponent, DialogData>(
            NotificationDialogComponent,
            {
                width: MatDialogWidth.LG,
                data: {
                    notifications: this.notifications(),
                },
            }
        );
    }
}
